import {setProductModel} from '../slices/configurationSlice';

// side effect: if only one model is available, select it automtically

export const productDataMiddleware = store => next => action => {
    const result = next(action);

    if (action.type === 'productData/models/fulfilled') {
        if (store.getState().productData.models && store.getState().productData.models.length > 0) {
			const modelids = store.getState().productData.models.map(model => model.productModelId);
			if (!modelids.includes(store.getState().configuration.data.projects[0].project.productModelId)) {
				//store.dispatch(setProductModel({
				//	productModel: store.getState().productData.models[0].productModelId
				//}));
			}
        }
    }
    return result;
};
